<script>
    export let group_name
    export let show_name
    export let location
    export let nameLength
    export let locationLength
    export let number
    export let category
    export let time_info_1day
    export let time_info_2day
    export let booking
    export let url
    export let point
    export let underLine

    import { openfront } from "../stores2.js"
    import { openbehind } from "../stores3.js"

    const close = () => {
        openfront.set(false)
        openbehind.set(false)
    }

    const front = () => {
        openfront.set(true)
        openbehind.set(false)
    }

    import { nightmode } from "../stores5"

    export function clickOutside(node) {
  
    const handleClick = event => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(
                new CustomEvent('click_outside', node)
            )
        }
    }

	document.addEventListener('click', handleClick, true);
  
    return {
        destroy() {
            document.removeEventListener('click', handleClick, true);
            }
	    }
    }
</script>

<div class="js-modal" class:night={$nightmode} id="modal" style="-webkit-text-size-adjust:100%; -webkit-appearance: none; -moz-appearance: none;">
    <div class="js-modal-behind" class:modal-behind-night={$nightmode} id="modal-behind" use:clickOutside on:click_outside={close}>
            <div class="modal-behind-group-info-title" class:modal-behind-group-info-title-night={$nightmode}>
                <div class="modal-behind-group-info-area-desc">Title/題名</div>
                <div class="modal-behind-group-info-area-title" style="font-size:{1000/(nameLength+50)}px;">{show_name}</div>
            </div>
            <div class="modal-behind-group-info-area-name" class:modal-behind-group-info-area-name-night={$nightmode}>
                <div class="modal-behind-group-info-area-small-desc">Group/団体</div>
                <div class="modal-behind-group-info-area-small-title" style="font-size:{300/(nameLength+10)}px;">{group_name}</div>
            </div>
            <div class="modal-behind-group-info-area-place" class:modal-behind-group-info-area-place-night={$nightmode}>
                <div class="modal-behind-group-info-area-small-desc">Place/場所</div>
                <div class="modal-behind-group-info-area-small-title" style="font-size:{300/(locationLength+13)}px;">{location}</div>
            </div>
            <div class="modal-behind-group-info-time" class:modal-behind-group-info-time-night={$nightmode} style="display: flex;flex-direction: column;align-items:flex-start;justify-content:strat;">
                <div class="modal-behind-group-info-area-small-desc" style="margin-top:5px;">Time-Schedule/スケジュール</div>
                <p style="font-size:18px; font-weight:600; margin:10px 0 10px 10px">1日目</p>
                {#each time_info_1day as { schedule, time, category }}
                    <ul>
                        <li>{schedule}<p>{time}/{category}</p></li>
                    </ul>
                {/each}
                <p style="font-size:18px; font-weight:600; margin:20px 0 10px 10px">2日目</p>
                {#each time_info_2day as { schedule, time, category }}
                    <ul>
                        <li>{schedule}<p>{time}/{category}</p></li>
                    </ul>
                {/each}
                <!--<p style="font-size:30px;font-weight: 600;letter-spacing: 0.05em;line-height: 1.2em;margin:5px 10px;">未定</p>-->
            </div>
            <div class="modal-behind-group-info-area-booking" class:modal-behind-group-info-area-booking-night={$nightmode}>
                <div class="modal-behind-group-info-area-small-desc">Booking/予約</div>
                <a class="modal-behind-group-info-area-small-title" style="pointer-events:{point}; text-decoration:{underLine};"  target="_blank" href="{url}">{booking}</a>
            </div>
            <div class="modal-behind-to-front" id="to-front" on:click={front}>表面へ→</div>
            <div class="modal-behind-group-number" class:modal-behind-group-number-night={$nightmode}>{number}</div>
            <div class="modal-behind-group-category" class:modal-behind-group-category-night={$nightmode}>{category}</div>
            <div class="modal-behind-date" class:modal-behind-date-night={$nightmode}>↓scroll down</div>
            <div style="grid-area:8/3/9/4; background-color:black;" on:click={front}></div>
            <div class="barcode" class:barcode-night={$nightmode}>
                <div style="width:3px; margin-right:2px;"></div>
                <div style="width:4px; margin-right:2px;"></div>
                <div style="width:7px; margin-right:2px;"></div>
                <div style="width:4px; margin-right:4px;"></div>
                <div style="width:3px; margin-right:2px;"></div>
                <div style="width:5px; margin-right:2px;"></div>
                <div style="width:3px; margin-right:2px;"></div>
                <div style="width:4px; margin-right:4px;"></div>
                <div style="width:5px; margin-right:2px;"></div>
                <div style="width:3px; margin-right:2px;"></div>
                <div style="width:3px; margin-right:2px;"></div>
                <div style="width:4px; margin-right:4px;"></div>
                <div style="width:6px; margin-right:2px;"></div>
                <div style="width:4px; margin-right:2px;"></div>
            </div>
    </div>
</div>


<style>
.night{
    background-color: rgba(66, 66, 66, 0.3);
}
a{
    color:black;
}
a:visited{
    color:black;
}
.js-modal{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background-color: rgba(100, 100, 100, 0.5);
    visibility: visible;
    opacity: 100;
    -webkit-transition: .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    z-index:10;
}
.js-modal-behind{
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform : translate(-50%,-50%) rotateY(0deg);
    transform : translate(-50%,-50%) rotateY(0deg);
    -webkit-transition: transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition:transform .3s cubic-bezier(0.215, 0.61, 0.355, 1);
    background-color: #ffffff;
    width:320px;
    height:720px;
    display:grid;
    grid-template-columns:50% 40% 10%;
    grid-template-rows: 20% 10% 7.5% 7.5% 20% 15% 15% 5%;
}
.modal-behind-night{
    background-color:#222831;
    color:#dddddd;
}
.modal-behind-group-info-title{
    grid-area:1/1/2/4;
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    border-bottom:dashed 1px black;
    white-space: pre-line;
}
.modal-behind-group-info-title-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-behind-group-info-area-desc{
    font-size:14px;
    font-weight:600;
    margin-bottom:6px;
    margin-left:10px;
}
.modal-behind-group-info-area-title{
    font-size:30px;
    font-weight:600;
    letter-spacing: .05em;
    margin-left:10px;
    margin-right:10px;
}
.modal-behind-group-info-area-name{
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    grid-area:2/1/3/3;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-behind-group-info-area-name-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-behind-group-info-area-place{
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    grid-area:3/1/4/3;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-behind-group-info-area-place-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-behind-group-info-area-booking{
    display: flex;
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    grid-area:4/1/5/3;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
}
.modal-behind-group-info-area-booking-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-behind-group-info-area-small-desc{
    font-size:14px;
    font-weight:600;
    margin-bottom:6px;
    margin-left:10px;
}
.modal-behind-group-info-area-small-title{
    font-size:18px;
    font-weight:600;
    letter-spacing: .05em;
    line-height:1.2em;
    text-align:left;
    white-space: pre-line;
    margin-left:10px;
    margin-right:10px;
}
.modal-behind-group-info-time{
    grid-area:5/1/8/3;
    border-bottom:dashed 1px black;
    border-right:dashed 1px black;
    overflow: scroll;
    justify-content: start;
}
.modal-behind-group-info-time::-webkit-scrollbar{
    width: 12px;
    background-color: #ffffff;
}
.modal-behind-group-info-time::-webkit-scrollbar-track{
    border-radius: 3px;
    background-color: transparent;
}
.modal-behind-group-info-time::-webkit-scrollbar-thumb{
    border-radius:5px;
    background-color:#a5a5a5;
    border:2px solid #ffffff;
}
.modal-behind-group-info-time-night{
    border-bottom:dashed 1px #dddddd;
    border-right:dashed 1px #dddddd;
}
.modal-behind-group-info-time ul{
    padding-left:0;
    margin:0;
    margin-left:10px;
}
.modal-behind-group-info-time li{
    font-size:30px;
    font-weight: 600;
    line-height: 1.2em;
    border-left: solid 6px black;
    margin:5px 0;
    padding-left:10px;
    list-style-type: none;
}
.modal-behind-group-info-time-night li{
    border-left: solid 6px #dddddd;
}
.modal-behind-group-info-time p{
    font-size:16px;
}
.modal-behind-to-front{
    font-size:12px;
    font-weight:600;
    grid-area:8/2/9/3;
    display: flex;
    align-items: center;
    justify-content:flex-start;
    cursor: pointer;
}
.modal-behind-group-number{
    font-size:10px;
    font-weight: 600;
    text-align: end;
    letter-spacing: 0.2em;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    justify-content:flex-end;
    grid-area:6/3/7/4;
    display: flex;
    align-items: center;
    border-bottom:dashed 1px black;
}
.modal-behind-group-number-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-behind-group-category{
    font-size:10px;
    font-weight:700;
    text-align: end;
    letter-spacing: 0.2em;
    grid-area:3/3/6/4;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    display: flex;
    align-items: center;
    justify-content:flex-end;
    border-bottom:dashed 1px black;
}
.modal-behind-group-category-night{
    border-bottom:dashed 1px #dddddd;
}
.modal-behind-date{
    grid-area:7/3/8/4;
    font-size:10px;
    font-weight:600;
    text-align: end;
    letter-spacing: 0.1em;
    -ms-writing-mode: tb-rl;
    writing-mode: vertical-rl;
    -webkit-text-orientation: sideways;
    text-orientation: sideways;
    display: flex;
    align-items: center;
    justify-content:flex-end;
}
.barcode{
    grid-area:8/1/9/2;
    height:100%;
    width:100%;
    display: flex;
}
.barcode div{
    background-color:black;
    height:100%;
}
.barcode-night div{
    background-color:#dddddd;
}
@media only screen and (min-height:667px) and (max-height:812px){
    .js-modal-behind{
        height:600px;
    }
}
@media  screen and (max-height:667px){
    .js-modal-behind{
        height:500px;
        width:280px;
    }
}
</style>